// Where the vendor-facing Terms & Conditions live (spec 2026-08-05). One
// constant shared by the vendor review step (the link) and the API submit
// handler (the acceptance version hash) so the two can never drift apart: a
// vendor's recorded terms_version then always identifies the document they were
// actually shown.
//
// Note what that hash does NOT do today: nothing reads or compares
// terms_version (written at me.ts, read nowhere), so repointing this URL does
// not re-prompt anyone for acceptance. Re-prompting would have to be built.
export const TERMS_URL = 'https://www.locate2u.com/legal/terms/';
